import { css } from '@emotion/react'
import { Tooltip } from 'bold-ui'
import { StatusPedidoEnvioEnum, StatusUnificacaoBaseEnum } from 'graphql/types.generated'
import { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'

import {
  aguardandoAprovacaoList,
  aguardandoUnificacaoList,
  baseUnificadaList,
  erroUnificacaoList,
  erroVersaoList,
  solicitacaoCanceladaList,
  unificacaoNegadaList,
  unificandoBaseList,
} from './model'
import StatusSolicitacaoTag from './StatusSolicitacaoTag'

export interface StatusUnificacaoBaseTagProps {
  status: StatusUnificacaoBaseEnum | StatusPedidoEnvioEnum
  dataFimUnificacao: string
  isLoginAtivo: boolean
}

export const StatusUnificacaoBaseTag = (props: StatusUnificacaoBaseTagProps) => {
  if (!props.isLoginAtivo) {
    return (
      <Tooltip text='Sessão expirada. Insira a senha novamente e acione a opção "Continuar unificação".'>
        <StatusSolicitacaoTag type='danger' icon='timesFilled'>
          Sessão expirada
        </StatusSolicitacaoTag>
      </Tooltip>
    )
  } else {
    return (
      <Fragment>
        {aguardandoAprovacaoList.includes(props.status) && (
          <Tooltip
            text={
              props.status in StatusUnificacaoBaseEnum
                ? 'Para dar continuidade, é necessário aceitar o pedido de solicitação de unificação.'
                : 'Aguardando a aprovação do administrador da instalação central do município para o envio de base.'
            }
          >
            <StatusSolicitacaoTag type='alert' icon='exclamationTriangleFilled'>
              Aguardando aprovação
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {aguardandoUnificacaoList.includes(props.status) && (
          <Tooltip
            text={
              props.status in StatusUnificacaoBaseEnum
                ? 'Aguardando o início da unificação de bases pelo administrador da instalação solicitante.'
                : 'Solicitação aprovada. Acionar a opção "Unificar" para dar continuidade na unificação de bases.'
            }
          >
            <StatusSolicitacaoTag type='alert' icon='exclamationTriangleFilled'>
              Aguardando unificação
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {unificandoBaseList.includes(props.status) && (
          <Tooltip text='As bases estão sendo unificadas. Aguarde até que o processo seja finalizado.'>
            <StatusSolicitacaoTag type='info' icon='clockFilled'>
              Unificando base
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {baseUnificadaList.includes(props.status) && (
          <Tooltip
            text={
              props.status in StatusUnificacaoBaseEnum
                ? 'Unificação de bases concluída.'
                : 'Unificação de bases concluída. Para acessar o sistema, utilize o link da instalação central do município.'
            }
          >
            <StatusSolicitacaoTag type='success' icon='checkCircleFilled'>
              Base unificada
              <span
                css={css`
                  font-weight: normal;
                `}
              >
                &nbsp;- {formatDate(props.dataFimUnificacao)}
              </span>
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {solicitacaoCanceladaList.includes(props.status) && (
          <Tooltip text='A solicitação de unificação de bases foi cancelada pelo solicitante.'>
            <StatusSolicitacaoTag type='normal' icon='banFilled'>
              Solicitação cancelada
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {unificacaoNegadaList.includes(props.status) && (
          <Tooltip text='A solicitação foi negada e não será possível continuar com o processo de unificação.'>
            <StatusSolicitacaoTag type='normal' icon='banFilled'>
              Unificação negada
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {erroUnificacaoList.includes(props.status) && (
          <Tooltip text='Unificação interrompida pois possui inconsistências no banco de dados. Entre em contato o suporte.'>
            <StatusSolicitacaoTag type='danger' icon='timesFilled'>
              Erro
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
        {erroVersaoList.includes(props.status) && (
          <Tooltip text='Uma das instalações foi atualizada e as versões estão diferentes. É necessário que ambas tenham a mesma versão.'>
            <StatusSolicitacaoTag type='danger' icon='timesFilled'>
              Erro
            </StatusSolicitacaoTag>
          </Tooltip>
        )}
      </Fragment>
    )
  }
}
